<template>
  <div class="h-full flex flex-col bg-gray-900 text-gray-100 rounded-lg overflow-hidden">
    <div class="flex-grow overflow-hidden">
      <div v-if="isEditMode" class="h-full p-4">
        <textarea 
          v-model="currentNote" 
          class="w-full h-full p-4 bg-gray-800 text-gray-100 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
          placeholder="Enter your note here..."
        ></textarea>
      </div>
      <div v-else class="h-full overflow-y-auto p-4 space-y-4">
        <div 
          v-for="(note, index) in notes" 
          :key="note.id" 
          class="bg-gray-800 p-4 rounded-lg shadow-md hover:shadow-lg transition duration-200 ease-in-out"
        >
          <div v-if="editingNoteId === note.id">
            <textarea 
              v-model="editingNoteText" 
              class="w-full p-2 bg-gray-700 text-gray-100 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
              rows="3"
            ></textarea>
            <div class="mt-2 flex justify-end space-x-2">
              <button 
                @click="saveNoteEdit(note.id)" 
                class="px-3 py-1 bg-green-600 hover:bg-green-700 text-white rounded-lg"
              >
                Save
              </button>
              <button 
                @click="cancelNoteEdit" 
                class="px-3 py-1 bg-red-600 hover:bg-red-700 text-white rounded-lg"
              >
                Cancel
              </button>
            </div>
          </div>
          <div v-else>
            <div v-if="note.text.length > 100" class="relative">
              <p :class="{ 'line-clamp-3': !expandedNotes[index] }">{{ note.text }}</p>
              <button 
                @click="toggleNoteExpansion(index)" 
                class="mt-2 text-blue-400 hover:text-blue-300 focus:outline-none"
              >
                {{ expandedNotes[index] ? 'Show less' : 'Show more' }}
              </button>
            </div>
            <p v-else>{{ note.text }}</p>
            <div class="flex justify-end space-x-2">
              <button 
                @click="startNoteEdit(note)" 
                class="mt-2 text-blue-400 hover:text-blue-300 focus:outline-none"
              >
                <i class="pi pi-pencil px-2 py-1"></i>
              </button>
              <button 
              @click="deleteNote(note.id)" 
                class="mt-2 text-red-400 hover:text-red-300 focus:outline-none"
              >
                <i class="pi pi-trash px-2 py-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-4 bg-gray-800 border-t border-gray-700">
      <div class="flex justify-between items-center">
        <button 
          @click="toggleView" 
          class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md hover:shadow-lg transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          {{ isEditMode ? 'View Notes' : 'New Note' }}
        </button>
        <button 
          v-if="isEditMode" 
          @click="saveNote" 
          class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-md hover:shadow-lg transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
        >
          Save Note
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NotepadTab',
  data() {
    return {
      isEditMode: false,
      currentNote: '',
      notes: [],
      expandedNotes: {},
      chatSession: '',
      editingNoteId: null,
      editingNoteText: '',
    }
  },
  methods: {
    toggleView() {
      this.isEditMode = !this.isEditMode;
    },
    saveNote() {
      if (this.currentNote.trim()) {
        // this.notes.unshift(this.currentNote);
        // this.expandedNotes[0] = false;
        this.uploadNote(this.currentNote);
        this.currentNote = '';
        this.isEditMode = false;
      }
    },
    toggleNoteExpansion(index) {
      this.$set(this.expandedNotes, index, !this.expandedNotes[index]);
    },
    addNote(text) {
    //   this.notes.unshift(text);
    //   this.expandedNotes[0] = false;
      this.uploadNote(text);
    },
    uploadNote(text) {
      axios.post(`${process.env.VUE_APP_BASE_URL}/add-note`, { 
        note: text,
        chat_session_id: this.chatSession,
        index: this.notes.length
      }, {
        headers: {
          'Token': `Bearer ${this.$cookies.get('pb_token')}`,
          'User': this.$cookies.get('pb_user'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        var note_id = response.data.note_id;
        this.notes.unshift({
          id: note_id,
          text: text,
          index: this.notes.length
        });
      }).catch(error => {
        console.error('Error adding note:', error);
      });
    },
    getNotes() {
      axios.get(`${process.env.VUE_APP_BASE_URL}/get-notes`, {
        params: {
          chatSession: this.chatSession
        },
        headers: {
          'Token': `Bearer ${this.$cookies.get('pb_token')}`,
          'User': this.$cookies.get('pb_user'),
        }
      }).then(response => {
        this.notes = response.data.notes.map(note => ({
          id: note['note_id'],
          text: note.note,
          index: note.index || this.notes.length
        }));
        this.notes.sort((a, b) => b.index - a.index);
      }).catch(error => {
        console.error('Error fetching notes:', error);
      });
    },
    startNoteEdit(note) {
      this.editingNoteId = note.id;
      this.editingNoteText = note.text;
      this.editingNoteIndex = note.index;
    },

    cancelNoteEdit() {
      this.editingNoteId = null;
      this.editingNoteText = '';
      this.editingNoteIndex = null;
    },

    deleteNote(noteId) {
      axios.delete(`${process.env.VUE_APP_BASE_URL}/delete-note`, {
        data: {
          note_id: noteId
        },
        headers: {
          'Token': `Bearer ${this.$cookies.get('pb_token')}`,
          'User': this.$cookies.get('pb_user'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        this.notes = this.notes.filter(note => note.id !== noteId);
      }).catch(error => {
        console.error('Error deleting note:', error);
      });
    },
    saveNoteEdit(noteId) {
      axios.patch(`${process.env.VUE_APP_BASE_URL}/update-note`, {
        note_id: noteId,
        note: this.editingNoteText,
        index: this.editingNoteIndex
      }, {
        headers: {
          'Token': `Bearer ${this.$cookies.get('pb_token')}`,
          'User': this.$cookies.get('pb_user'),
          'Content-Type': 'application/json'
        }
      }).then(response => {
        const updatedNoteIndex = this.notes.findIndex(note => note.id === noteId);
        if (updatedNoteIndex !== -1) {
          this.notes[updatedNoteIndex].text = this.editingNoteText;
        }
        this.cancelNoteEdit();
      }).catch(error => {
        console.error('Error updating note:', error);
      });
    },
  },
  async mounted() {
    this.chatSession = this.$route.params.p;
    this.getNotes();
  }
}
</script>

<style scoped>
/* Make the buttons translucent */
button {
  opacity: 0.8;
}

/* Make the buttons more opaque on hover */
button:hover {
  opacity: 1;
}
</style>